import axios from 'axios';

const enteFunciones = {
    // Función para cargar los ente conformadores
    obtenerEntesConformadores: async () => {
        try {
            const response = await axios.get('/api/ente/listall');
            console.log("Lista de ente conformadores:", response.data);
            return response.data.entesConformadores || []; // Retorna los ente conformadores si están disponibles
        } catch (error) {
            console.error("Error al obtener la lista de ente conformadores:", error.message);
            return []; // Retorna un arreglo vacío en caso de error
        }
    },

    // Función para cargar los jefes inmediatos
    obtenerJefes: async () => {
        try {
            const response = await axios.get('/api/jefe/listall');
            console.log("Lista de jefes inmediatos:", response.data);
            return response.data.jefes || []; // Retorna los jefes si están disponibles
        } catch (error) {
            console.error("Error al obtener la lista de jefes inmediatos:", error.message);
            return []; // Retorna un arreglo vacío en caso de error
        }
    },
};

export default enteFunciones;
